module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="availability-grid">\n    <div class="availability-grid__header">\n        <div class="availability-grid__header-empty"></div>\n        <div class="availability-grid__header-content"><span>Definitely not</span></div>\n        <div class="availability-grid__header-content"><span>Preferably not</span></div>\n        <div class="availability-grid__header-content"><span>It\'s OK</span></div>\n        <div class="availability-grid__header-content"><span>Preferred</span></div>\n    </div>\n    <div class="availability-grid__body">\n        <form>\n            <div class="availability-grid__row">\n                <div class="availability-grid__label">\n                    <span>Day shifts</span>\n                    ';
 if (!disabled) { ;
__p += '\n                        <span class="tooltip" data-tooltip="Shifts that start between 4am and noon, e.g. 6am–4pm, 9:30am–5pm">\n                            ' +
((__t = ( $.svgIcon('help-circle') )) == null ? '' : __t) +
'\n                        </span>\n                    ';
 } ;
__p += '\n                </div>\n                ';
 [1,2,3,4].forEach(function(i) { ;
__p += '\n                    <div class="availability-grid__checkbox">\n                        <input\n                            id="' +
__e( prefix ) +
'pref_shift_day' +
__e( i ) +
'"\n                            type="radio"\n                            name="pref_shift_day"\n                            value="' +
__e( i ) +
'"\n                            ';
 if (disabled) { ;
__p += 'disabled';
 } ;
__p += '\n                            ';
 if (pref_shift_day == i || (!pref_shift_day && i === 4)) { ;
__p += 'checked';
 } ;
__p += '\n                        />\n                        <label for="' +
__e( prefix ) +
'pref_shift_day' +
__e( i ) +
'">' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'</label>\n                    </div>\n                ';
 }) ;
__p += '\n            </div>\n            <div class="availability-grid__row">\n                <div class="availability-grid__label">\n                    <span>Swing shifts</span>\n                    ';
 if (!disabled) { ;
__p += '\n                        <span class="tooltip" data-tooltip="Shifts that start between noon and 4pm, e.g. 3:30pm–11pm, 1pm–9pm">\n                            ' +
((__t = ( $.svgIcon('help-circle') )) == null ? '' : __t) +
'\n                        </span>\n                    ';
 } ;
__p += '\n                </div>\n                ';
 [1,2,3,4].forEach(function(i) { ;
__p += '\n                    <div class="availability-grid__checkbox">\n                        <input\n                            id="' +
__e( prefix ) +
'pref_shift_swing' +
__e( i ) +
'"\n                            type="radio"\n                            class="pref-shift"\n                            name="pref_shift_swing"\n                            value="' +
__e( i ) +
'"\n                            ';
 if (disabled) { ;
__p += 'disabled';
 } ;
__p += '\n                            ';
 if (pref_shift_swing == i || (!pref_shift_swing && i === 3)) { ;
__p += 'checked';
 } ;
__p += '\n                        />\n                        <label for="' +
__e( prefix ) +
'pref_shift_swing' +
__e( i ) +
'">' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'</label>\n                    </div>\n                ';
 }) ;
__p += '\n            </div>\n            <div class="availability-grid__row">\n                <div class="availability-grid__label">\n                    <span>Night shifts</span>\n                    ';
 if (!disabled) { ;
__p += '\n                        <span class="tooltip" data-tooltip="Shifts that start between 4pm and 4am, e.g. 11pm–7am, 8pm–4am">\n                            ' +
((__t = ( $.svgIcon('help-circle') )) == null ? '' : __t) +
'\n                        </span>\n                    ';
 } ;
__p += '\n                </div>\n                ';
 [1,2,3,4].forEach(function(i) { ;
__p += '\n                    <div class="availability-grid__checkbox">\n                        <input\n                            id="' +
__e( prefix ) +
'pref_shift_night' +
__e( i ) +
'"\n                            type="radio"\n                            class="pref-shift"\n                            name="pref_shift_night"\n                            value="' +
__e( i ) +
'"\n                            ';
 if (disabled) { ;
__p += 'disabled';
 } ;
__p += '\n                            ';
 if (pref_shift_night == i || (!pref_shift_night && i === 2)) { ;
__p += 'checked';
 } ;
__p += '\n                        />\n                        <label for="' +
__e( prefix ) +
'pref_shift_night' +
__e( i ) +
'">' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'</label>\n                    </div>\n                ';
 }) ;
__p += '\n            </div>\n            <div class="availability-grid__row">\n                <div class="availability-grid__label">\n                    Weekends\n                </div>\n                ';
 [1,2,3,4].forEach(function(i) { ;
__p += '\n                    <div class="availability-grid__checkbox">\n                        <input\n                            id="' +
__e( prefix ) +
'pref_shift_weekend' +
__e( i ) +
'"\n                            type="radio"\n                            class="pref-shift"\n                            name="pref_shift_weekend"\n                            value="' +
__e( i ) +
'"\n                            ';
 if (disabled) { ;
__p += 'disabled';
 } ;
__p += '\n                            ';
 if (pref_shift_weekend == i || (!pref_shift_weekend && i === 3)) { ;
__p += 'checked';
 } ;
__p += '\n                        />\n                        <label for="' +
__e( prefix ) +
'pref_shift_weekend' +
__e( i ) +
'">' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'</label>\n                    </div>\n                ';
 }) ;
__p += '\n            </div>\n            <div class="availability-grid__row">\n                <div class="availability-grid__label">\n                    Overtime\n                </div>\n                ';
 [1,2,3,4].forEach(function(i) { ;
__p += '\n                    <div class="availability-grid__checkbox">\n                        <input\n                            id="' +
__e( prefix ) +
'pref_shift_overtime' +
__e( i ) +
'"\n                            type="radio"\n                            class="pref-shift"\n                            name="pref_shift_overtime"\n                            value="' +
__e( i ) +
'"\n                            ';
 if (disabled) { ;
__p += 'disabled';
 } ;
__p += '\n                            ';
 if (pref_shift_overtime == i || (!pref_shift_overtime && i === 3)) { ;
__p += 'checked';
 } ;
__p += '\n                        />\n                        <label for="' +
__e( prefix ) +
'pref_shift_overtime' +
__e( i ) +
'">' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'</label>\n                    </div>\n                ';
 }) ;
__p += '\n            </div>\n        </form>\n\n        <div class="availability-grid__invalid" style="display: none">\n            <div class="availability-grid__invalid-content">\n                <header>\n                    <strong>It doesn\'t look like you\'re available for any standard shifts!</strong>\n                </header>\n\n                <section>\n                    <p>\n                        You\'ve marked Day, Swing, and Night shifts as "Definitely not"\n                    </p>\n                    <p>\n                        ';
 if (isApp) { ;
__p += '\n                            To continue applying, you must specify you can work at least\n                            one of these shifts.\n                        ';
 } else { ;
__p += '\n                            You must specify you can work at least one of these shifts.\n                        ';
 } ;
__p += '\n                    </p>\n                </section>\n\n                <footer>\n                    <a href="#" class="availability-grid__invalid-close">Got it</a>\n                </footer>\n            </div>\n        </div>\n    </div>\n</section>\n';

}
return __p
}